import React, { FC } from 'react';
import { styled } from 'linaria/react';
import SpinnerIcon from '@shared/assets/icons/SpinnerIcon';
import { withTheme } from '@shared/lib/theme';
const Spinner: FC = () => <SpinnerWrapper>
    <SpinnerIcon />
  </SpinnerWrapper>;
export default Spinner;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.primary;
const SpinnerWrapper = withTheme(/*#__PURE__*/styled('span')({
  name: "SpinnerWrapper",
  class: "smoq5o1",
  propsAsIs: false,
  vars: {
    "smoq5o1-0": [_exp()]
  }
}));

require("./Spinner.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Spinner.tsx");